import { useLanguage } from '../contexts/language';

export const useLanguageFont = () => {
  const { currentLang } = useLanguage();
  
  const getFontClass = () => {
    switch (currentLang) {
      case 'en':
        return 'font-lang-en';
      case 'ku':
        return 'font-lang-ku';
      case 'ar':
        return 'font-lang-ar';
      default:
        return 'font-lang-en';
    }
  };
  
  return {
    fontClass: getFontClass(),
    currentLang
  };
};
